import React, { useState } from "react";
import {
  Card,
  CardContent,
  CardMedia,
  Typography,
  Button,
  Grid,
  Box,
  Dialog,
  DialogTitle,
  DialogContent,
  TextField,
  DialogActions,
} from "@mui/material";
import { registerUser } from "../Allapi/Api";
import Swal from "sweetalert2";
import img1 from "../img/71dr8CjyjrL._AC_UF1000,1000_QL80_.jpg";
import img2 from "../img/81jXMxTzLRL._AC_UF1000,1000_QL80_.jpg";
import img3 from "../img/download (1).jpeg";
import img4 from "../img/download.jpeg";
import LoginForm from "./LoginForm"; // Adjust the path as necessary

const cardData = [
  {
    id: 1,
    title: "अंक 14 वा चालू घडामोडी टेस्ट",
    image: img1,
    testName: "Test A",
    testDate: "16 एप्रिल 2025",
  },
  {
    id: 2,
    title: "अंक 15 वा चालू घडामोडी टेस्ट",
    image: img2,
    testName: "Test B",
    testDate: "23 एप्रिल 2025",
  },
  {
    id: 3,
    title: "अंक 16 वा चालू घडामोडी टेस्ट",
    image: img3,
    testName: "Test C",
    testDate: "30 एप्रिल 2025",
  },
  {
    id: 4,
    title: "अंक 17 वा चालू घडामोडी टेस्ट",
    image: img4,
    testName: "Test D",
    testDate: "5 एप्रिल 2025",
  },
];

const CourseCards = () => {
  const [openRegister, setOpenRegister] = useState(false);
  const [openTest, setOpenTest] = useState(false);
  const [openResult, setOpenResult] = useState(false);
  const [selectedTest, setSelectedTest] = useState(null);
  const [formData, setFormData] = useState({
    name: "",
    mobNo: "",
    email: "",
    examName: "",
    password: "",
  });

  const handleOpenRegister = () => setOpenRegister(true);
  const handleCloseRegister = () => setOpenRegister(false);

  const handleOpenTest = (test) => {
    setSelectedTest(test);
    setOpenTest(true);
  };
  const handleCloseTest = () => setOpenTest(false);

  const handleOpenResult = (test) => {
    setSelectedTest(test);
    setOpenResult(true);
  };
  const handleCloseResult = () => setOpenResult(false);

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async () => {
    const success = await registerUser(formData);
    if (success) {
      Swal.fire("Success", "User registered successfully", "success");
      setOpenRegister(false);
    } else {
      Swal.fire("Error", "Registration failed", "error");
    }
  };
  return (
    <Box sx={{ flexGrow: 1, padding: 2 }}>
      <Grid container spacing={3} justifyContent="center">
        {cardData.map((card) => (
          <Grid item xs={12} sm={6} md={3} key={card.id}>
            <Card sx={{ maxWidth: 345, borderRadius: 3, boxShadow: 5 }}>
              <CardMedia
                component="img"
                height="280"
                image={card.image}
                alt={card.title}
                sx={{ width: "100%", objectFit: "fill" }}
              />

              <CardContent>
                <Typography variant="h6" align="center" gutterBottom>
                  {card.title}
                </Typography>
                <Box display="flex" justifyContent="center" gap={1}>
                  <Button
                    variant="contained"
                    color="primary"
                    size="small"
                    onClick={() => setOpenRegister(true)}
                  >
                    Register
                  </Button>
                  <Button
                    variant="outlined"
                    color="secondary"
                    size="small"
                    onClick={() => handleOpenTest(card)}
                  >
                    Solve Test
                  </Button>
                  <Button
                    variant="contained"
                    color="success"
                    size="small"
                    onClick={() => handleOpenResult(card)}
                  >
                    Result
                  </Button>
                </Box>
              </CardContent>
            </Card>
          </Grid>
        ))}
      </Grid>

      {/* Register/Login Modal */}
      <Dialog
        open={openRegister}
        onClose={handleCloseRegister}
        maxWidth="sm"
        fullWidth
      >
        <DialogTitle>Login</DialogTitle>
        <DialogContent>
          <LoginForm onClose={handleCloseRegister} />
        </DialogContent>
      </Dialog>

      {/* Solve Test Modal */}
      <Dialog open={openTest} onClose={handleCloseTest}>
        <DialogTitle>Solve Test</DialogTitle>
        <DialogContent>
          {selectedTest && (
            <Typography variant="h6">
              रैंकिंग टेस्ट दिनांक {selectedTest.testDate} रोजी संध्याकाळी 6
              वाजता सुरू होईल
            </Typography>
          )}
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCloseTest} color="secondary">
            Close
          </Button>
          <Button color="primary">Start Test</Button>
        </DialogActions>
      </Dialog>

      {/* Result Modal */}
      <Dialog open={openResult} onClose={handleCloseResult}>
        <DialogTitle>Test Result</DialogTitle>
        <DialogContent>
          {selectedTest && (
            <Typography variant="h6">
              रैंकिंग टेस्ट निकाल दिनांक {selectedTest.testDate} रोजी संध्याकाळी
              8 वाजता जाहीर करण्यात येईल
            </Typography>
          )}
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCloseResult} color="secondary">
            Close
          </Button>
        </DialogActions>
      </Dialog>
    </Box>
  );
};

export default CourseCards;
